import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Avatar from '@material-ui/core/Avatar'

const styles = {
  avatar: {
    width: 120,
    height: 120,
    background: '#002d72',
    color: '#fff',
    fontSize: '2rem'
  },
  text: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    margin: 'auto',
    textAlign: 'center',
    zIndex: 1,
    color: '#fff',
    background: 'rgba(0,0,0,0.5)',
    padding: '.7rem 1rem',
    fontSize: '.85rem',
    transform: 'translate(0, 100%)',
    transition: '.15s ease-in-out',
    visibility: 'hidden'
  },
  textWithFallback: {
    transform: 'translate(0, 0)',
    visibility: 'visible'
  },
  row: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '50%'
  },
  rowEdit: {
    '&:hover span': {
      transform: 'translate(0, 0)',
      visibility: 'visible'
    }
  },
  readOnly: {
    cursor: 'default'
  }
}

const getFallBackImage = (src, name) => {
  let initials = name
    .trim()
    .split(' ')
    .map(item => item[0])
  initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase()
  return src ? '' : initials
}

const handledAvatarClassNames = (classes, readOnly) => {
  if (readOnly) return classNames(classes.row, classes.readOnly)
  return classNames(classes.row, classes.rowEdit)
}

const AuthorAvatar = props => {
  const { classes, name = '', src, readOnly } = props
  const fallbackImage = getFallBackImage(src, name)
  const textClasses = name || src ? [classes.text] : [classes.text, classes.textWithFallback]

  return (
    <div className={handledAvatarClassNames(classes, readOnly)}>
      <span className={classNames(...textClasses)}>
        {src ? 'Alterar Imagem' : 'Adicionar imagem'}
      </span>
      <Avatar
        alt={name}
        src={src}
        style={{ background: src ? '#999' : '#002d72' }}
        className={classNames(classes.avatar)}
      >
        {fallbackImage}
      </Avatar>
    </div>
  )
}

AuthorAvatar.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(AuthorAvatar)



// WEBPACK FOOTER //
// ./src/components/AuthorAvatar.js